import { render, staticRenderFns } from "./base.vue?vue&type=template&id=a19a2010&scoped=true"
import script from "./base.vue?vue&type=script&lang=js"
export * from "./base.vue?vue&type=script&lang=js"
import style0 from "./base.vue?vue&type=style&index=0&id=a19a2010&prod&lang=scss"
import style1 from "./base.vue?vue&type=style&index=1&id=a19a2010&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a19a2010",
  null
  
)

export default component.exports